export default __webpack_public_path__ + "img/bg-tab1and2_nav-399432c0.png";